/* eslint-disable react/no-unused-prop-types */
import { Component, Fragment } from 'react';
import Select from 'react-select';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import {default as cx} from 'classnames';
import ErrorComponent from './ErrorComponent';
import hasErrors from '../../../helper/form/hasErrors';

const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  clear: both;
  margin: 0px;
  
  &.has-value label{
    top: 4px;
    font-size: 12px;
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      top: 0px;
    }
  }
`;

const Label = styled.label`
    position: absolute;
    left: 10px;
    top: ${({ props }) => (props.focus ? '4px' : '13px')};
    display: inline-block;
    pointer-events: none;
    color: #808080;
    cursor: text;
    font-size: ${({ props }) => (props.focus ? '12px' : '18px')};
    line-height: 16px;
    box-sizing: border-box;
    transition: all 200ms;
    
`;

class ReactSelectComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false, focus: false };
  }

  render() {
    const {
      id,
      label,
      className,
      errors,
      value,
      styles,
    } = this.props;

    const { open, focus } = this.state;

    const defaultStyles = {
      container: provided => ({
        ...provided,
        display: 'inline-block',
        width: '100%',
        marginLeft: '0',
        height: '46px',
        outline: '0 !important',
        border: '0 !important',
        boxSizing: 'border-box',
        ...styles.container,
      }),
      control: (provided, reactSelectState) => ({
        ...provided,
        backgroundColor: '#ffffff',
        boxShadow: 'none',
        borderWidth: reactSelectState.isFocused ? '2px' : '1px',
        borderColor: 'transparent',
        padding: 0,
        fontSize: '14px',
        borderRadius: '4px',
        letterSpacing: 'normal',
        height: '100%',
        ...styles.control,
      }),
      option: provider => ({
        ...provider,
        minHeight: '42px',
        ...styles.option,
      }),
      placeholder: () => ({
        display: 'none',
        ...styles.placeholder,
      }),
      input: provided => ({
        ...provided,
        fontFamily: 'Open Sans, sans-serif',
        fontSize: '18px',
        fontWeight: 600,
        margin: '8px 2px 0',
        ...styles.input,
      }),
      valueContainer: provided => ({
        ...provided,
        padding: '4px 8px 0',
        height: '100%',
        ...styles.valueContainer,
      }),
      indicatorSeparator: (provided, reactSelectState) => ({
        ...provided,
        margin: 0,
        width: reactSelectState.isFocused ? '2px' : '1px',
        ...styles.indicatorSeparator,
      }),
      indicatorsContainer: provided => ({
        ...provided,
        height: '100%',
        backgroundColor: '#f1f1f1',
        borderBottomRightRadius: '4px',
        borderTopRightRadius: '4px',
        ...styles.indicatorsContainer,
      }),
      dropdownIndicator: (provided, reactSelectState) => ({
        ...provided,
        color: 'black',
        width: reactSelectState.isFocused ? '43px' : '45px',
        svg: {
          height: '15px',
          transform: reactSelectState.isFocused ? 'rotate(180deg)' : 'rotate(0)',
          transition: 'transform 200ms',
        },
        padding: '0 5px 0',
        height: '100%',
        lineHeight: '46px',
        justifyContent: 'center',
        alignItems: 'center',
        ...styles.dropdownIndicator,
      }),
      menu: (provided, reactSelectState) => ({
        ...provided,
        border: reactSelectState.isFocused ? '0px solid transparent' : '1px solid transparent',
        ...styles.menu,
      }),
      menuList: provided => ({ ...provided, ...styles.menuList }),
      singleValue: provided => ({
        ...provided,
        fontFamily: '"Open Sans", sans-serif',
        fontSize: '18px',
        fontWeight: 600,
        width: '100%',
        height: '22px',
        top: '22px',
        lineHeight: '22px',
        margin: '6px 2px 0',
        ...styles.singleValue,
      }),
    };

    return (
      <Fragment>
        <SelectContainer
          className={cx('react-select', {
            'has-errors': hasErrors(errors),
            'is-open': open,
            'has-value': (value !== null),
            'has-focus': focus,
          }, className)}
        >
          <Select
            {...this.props}
            classNamePrefix="select"
            onBlur={() => this.setState({ focus: false })}
            onFocus={() => this.setState({ focus: true })}
            onMenuClose={() => this.setState({ open: false })}
            onMenuOpen={() => this.setState({ open: true })}
            styles={defaultStyles}
            filterOption={(candidate, query) => {
              if (query) {
                return candidate.label.toUpperCase().startsWith(query.toUpperCase());
              }

              return true;
            }}
          />
          <Label htmlFor={id} props={this.state}>{label}</Label>
        </SelectContainer>
        <ErrorComponent errors={errors} />
      </Fragment>
    );
  }
}

ReactSelectComponent.propTypes = {
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  id: PropTypes.string.isRequired,
  isSearchable: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  noOptionsMessage: PropTypes.func,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.any })).isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.shape({}),
  styles: PropTypes.shape({
    container: PropTypes.object,
    control: PropTypes.object,
    placeholder: PropTypes.object,
    input: PropTypes.object,
    valueContainer: PropTypes.object,
    indicatorSeparator: PropTypes.object,
    indicatorsContainer: PropTypes.object,
    dropdownIndicator: PropTypes.object,
    menu: PropTypes.object,
    menuList: PropTypes.object,
    singleValue: PropTypes.object,
  }),
};

ReactSelectComponent.defaultProps = {
  autoFocus: false,
  className: null,
  errors: null,
  isSearchable: false,
  styles: {},
  name: '',
  noOptionsMessage: () => 'Geen resultaten',
  onChange: () => {},
  placeholder: 'Zoeken',
  value: null,
};

export default ReactSelectComponent;
